import React from 'react';

import createSvgIcon from './hoc/createSvgIcon';

export default createSvgIcon(
  () => (
    <>
      <path
        d="M12.8571 14H17.1429L20 8V5.72205e-06L11 0V7.99999L15.7143 8L12.8571 14ZM1.85714 14H6.14286L9 8V5.72205e-06H0V8H4.71429L1.85714 14Z"
        fill="black"
        fillOpacity="0.6"
      />
    </>
  ),
  'Block Quote',
  '0 0 24 14'
);
